import React, { lazy } from 'react';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  return <section id="testimonios" className="py-12 mb-12" data-id="element-565">
      <div className="max-w-3xl mx-auto" data-id="element-566">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-center text-amber-900 mb-8" data-id="element-567">
          Lo que dicen nuestros alumnos
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-568">
          <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-569">
            <div className="flex items-center mb-4" data-id="element-570">
              <img src="https://images.unsplash.com/photo-1567532939604-b6b5b0db2604?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=150&q=80" alt="María Elena R." className="w-14 h-14 rounded-full object-cover mr-4 border-2 border-amber-200" loading="lazy" data-id="element-571" />
              <div data-id="element-572">
                <div className="flex mb-1" data-id="element-573">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} className="text-amber-500 fill-amber-500" data-id="element-574" />)}
                  <span className="ml-2 text-amber-800 font-bold" data-id="element-575">5/5</span>
                </div>
                <p className="font-medium text-amber-900" data-id="element-576">
                  María Elena R. - Montevideo, Uruguay
                </p>
              </div>
            </div>
            <p className="text-gray-700" data-id="element-577">
              "Después de años intentando hacer milhojas sin éxito, finalmente
              logré una perfecta siguiendo el método de Stella. Ahora vendo 15
              por semana desde casa."
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-578">
            <div className="flex items-center mb-4" data-id="element-579">
              <img src="https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=150&q=80" alt="Carmen S." className="w-14 h-14 rounded-full object-cover mr-4 border-2 border-amber-200" loading="lazy" data-id="element-580" />
              <div data-id="element-581">
                <div className="flex mb-1" data-id="element-582">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} className="text-amber-500 fill-amber-500" data-id="element-583" />)}
                  <span className="ml-2 text-amber-800 font-bold" data-id="element-584">5/5</span>
                </div>
                <p className="font-medium text-amber-900" data-id="element-585">
                  Carmen S. - Buenos Aires, Argentina
                </p>
              </div>
            </div>
            <p className="text-gray-700" data-id="element-586">
              "Los secretos que comparte Stella son oro puro. Las capas quedan
              perfectas y el merengue nunca se baja. Mi familia no puede creer
              el cambio."
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-587">
            <div className="flex items-center mb-4" data-id="element-588">
              <img src="https://images.unsplash.com/photo-1619895862022-09114b41f16f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=150&q=80" alt="Ana Lucía M." className="w-14 h-14 rounded-full object-cover mr-4 border-2 border-amber-200" loading="lazy" data-id="element-589" />
              <div data-id="element-590">
                <div className="flex mb-1" data-id="element-591">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} className="text-amber-500 fill-amber-500" data-id="element-592" />)}
                  <span className="ml-2 text-amber-800 font-bold" data-id="element-593">5/5</span>
                </div>
                <p className="font-medium text-amber-900" data-id="element-594">
                  Ana Lucía M. - Córdoba, Argentina
                </p>
              </div>
            </div>
            <p className="text-gray-700" data-id="element-595">
              "Increíble cómo Stella explica cada detalle. Logré mi primera
              milhojas perfecta al primer intento. Ahora hago pedidos para
              cumpleaños."
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-596">
            <div className="flex items-center mb-4" data-id="element-597">
              <img src="https://images.unsplash.com/photo-1607990281513-2c110a25bd8c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=150&q=80" alt="Roberto P." className="w-14 h-14 rounded-full object-cover mr-4 border-2 border-amber-200" loading="lazy" data-id="element-598" />
              <div data-id="element-599">
                <div className="flex mb-1" data-id="element-600">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} className="text-amber-500 fill-amber-500" data-id="element-601" />)}
                  <span className="ml-2 text-amber-800 font-bold" data-id="element-602">5/5</span>
                </div>
                <p className="font-medium text-amber-900" data-id="element-603">
                  Roberto P. - Punta del Este, Uruguay
                </p>
              </div>
            </div>
            <p className="text-gray-700" data-id="element-604">
              "Tengo una pequeña confitería y las milhojas de Stella son mi
              estrella. Los clientes siempre preguntan cuál es mi secreto."
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-605">
            <div className="flex items-center mb-4" data-id="element-606">
              <img src="https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=150&q=80" alt="Gabriela T." className="w-14 h-14 rounded-full object-cover mr-4 border-2 border-amber-200" loading="lazy" data-id="element-607" />
              <div data-id="element-608">
                <div className="flex mb-1" data-id="element-609">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} className="text-amber-500 fill-amber-500" data-id="element-610" />)}
                  <span className="ml-2 text-amber-800 font-bold" data-id="element-611">5/5</span>
                </div>
                <p className="font-medium text-amber-900" data-id="element-612">
                  Gabriela T. - Santiago, Chile
                </p>
              </div>
            </div>
            <p className="text-gray-700" data-id="element-613">
              "¡Increíble! En mi primer mes vendiendo milhojas gané $500
              dólares. El curso de Stella es una inversión que se paga sola. Las
              técnicas son precisas y fáciles de seguir."
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-614">
            <div className="flex items-center mb-4" data-id="element-615">
              <img src="https://images.unsplash.com/photo-1583864697784-a0efc8379f70?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=150&q=80" alt="Luis F." className="w-14 h-14 rounded-full object-cover mr-4 border-2 border-amber-200" loading="lazy" data-id="element-616" />
              <div data-id="element-617">
                <div className="flex mb-1" data-id="element-618">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} className="text-amber-500 fill-amber-500" data-id="element-619" />)}
                  <span className="ml-2 text-amber-800 font-bold" data-id="element-620">5/5</span>
                </div>
                <p className="font-medium text-amber-900" data-id="element-621">
                  Luis F. - Rosario, Argentina
                </p>
              </div>
            </div>
            <p className="text-gray-700" data-id="element-622">
              "Comencé vendiendo a familiares y en mi primer mes ya había ganado
              $320 dólares. Ahora, tres meses después, tengo pedidos de dos
              cafeterías locales. ¡La receta de Stella cambió mi vida
              económica!"
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm md:col-span-2" data-id="element-623">
            <div className="flex items-center mb-4" data-id="element-624">
              <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=150&q=80" alt="Patricia G." className="w-14 h-14 rounded-full object-cover mr-4 border-2 border-amber-200" loading="lazy" data-id="element-625" />
              <div data-id="element-626">
                <div className="flex mb-1" data-id="element-627">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} className="text-amber-500 fill-amber-500" data-id="element-628" />)}
                  <span className="ml-2 text-amber-800 font-bold" data-id="element-629">5/5</span>
                </div>
                <p className="font-medium text-amber-900" data-id="element-630">
                  Patricia G. - Mendoza, Argentina
                </p>
              </div>
            </div>
            <p className="text-gray-700" data-id="element-631">
              "El método es tan claro que hasta mi hijo de 16 años hace milhojas
              perfectas. Ya vendimos más de 50 este mes. ¡Gracias Stella!"
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm md:col-span-2" data-id="element-632">
            <div className="flex items-center mb-4" data-id="element-633">
              <img src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=150&q=80" alt="Marcela V." className="w-14 h-14 rounded-full object-cover mr-4 border-2 border-amber-200" loading="lazy" data-id="element-634" />
              <div data-id="element-635">
                <div className="flex mb-1" data-id="element-636">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} className="text-amber-500 fill-amber-500" data-id="element-637" />)}
                  <span className="ml-2 text-amber-800 font-bold" data-id="element-638">5/5</span>
                </div>
                <p className="font-medium text-amber-900" data-id="element-639">
                  Marcela V. - Bogotá, Colombia
                </p>
              </div>
            </div>
            <p className="text-gray-700" data-id="element-640">
              "Nunca pensé que podría ganar dinero desde casa. Mi primera
              milhojas fue un éxito, y para el final del primer mes había ganado
              $480 dólares vendiendo solo los fines de semana. Ahora tengo una
              pequeña empresa de repostería gracias a Stella."
            </p>
          </div>
        </div>
        
      </div>
    </section>;
}